// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"src-app-terminology-__features-module___iconContainer","pictureCover":"src-app-terminology-__features-module___pictureCover","withIcon":"src-app-terminology-__features-module___withIcon","iconStrip":"src-app-terminology-__features-module___iconStrip"};


//////////////////
// WEBPACK FOOTER
// ./src/app/terminology/features.module.css
// module id = 136
// module chunks = 0